import { Box, useTheme } from '@mui/material';
import FormLocationButton from '../../../../buttons/FormLocationButton';
import { FC } from 'react';
import { CustomFormField, SpeciesForm } from '../../../../../api/dtos/dtos';

interface ICustomLocationButtonProps {
    field: CustomFormField,
    form: SpeciesForm
}

const CustomLocationButton : FC<ICustomLocationButtonProps> = () => {
    //
    // -- Hooks --
    const theme = useTheme();

    return (
        <Box
            sx={{ 
                display: 'none',
                [theme.breakpoints.down('lg')]: {
                    display: 'block'
                }
            }}
        >
            <FormLocationButton />
        </Box>
    )
}

export default CustomLocationButton